<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container :style="cssProps">
        <h2 v-if="!exibirResumo(pedido.status_pedido)" class="titulo">DETALHES DA VENDA</h2>
        <v-stepper class="card" v-if="exibirResumo(pedido.status_pedido)" v-model="current_page">
            <v-row justify="center" class="header-steps">
                <v-col class="d-flex steps-container">
                    <template v-for="(step, i) in Steps">
                        <v-stepper-step :key="i" class="flex justify-center" :complete="current_page > i + 1"
                                        :step="i + 1">
                            <p class="step-label titulo">
                                <v-icon>{{ step.icon }}</v-icon>
                                {{ step.text }}
                            </p>
                        </v-stepper-step>
                    </template>
                </v-col>
            </v-row>
            <v-stepper-items class="step-content">
                <Confirmacao :tela="'resumo'" v-model="pedido" />
            </v-stepper-items>
        </v-stepper>
        <div v-else>
            <v-layout wrap class="justify-center">
                <v-flex xs12 md10>
                    <div class="d-flex justify-center">
                        <v-row class="mt-2 mb-2">
                            <v-col cols="12" lg="4" class="order-lg-3"> </v-col>
                            <v-col cols="6" lg="4" class="order-lg-2 mx-auto" align-self="center">
                                <img v-if="pedido.bem.id_bem" :src="`${ws}/compra/imagembem/${pedido.bem.id_bem}`"
                                     alt="" style="flex: none !important; height: auto; width: 100%; object-fit: cover;"
                                     class="mt-2" />
                            </v-col>
                            <v-col cols="12" lg="4" class="order-lg-1 mx-auto">
                                <IndicadorDecisaoCredito v-show="is_venda_reprovada || is_venda_aprovada"
                                                         :is-reprovada="is_venda_reprovada" :is-aprovada="is_venda_aprovada"
                                                         :motivo="pedido.motivo_decisao_credito" :id-pedido="pedido.id_pedido" />
                                <v-layout v-if="houve_pendencia">
                                    <v-btn small class="transition mr-4 mt-4" color="primary" @click="abrirHistoricoPendencias()">
                                        Histórico de Pendências
                                    </v-btn>
                                </v-layout>
                            </v-col>
                        </v-row>
                    </div>

                    <div>
                    </div>

                    <v-col class="d-flex justify-center mb-2"
                           v-if="!isVendaNaoGerada(pedido.status_pedido) && exibe_contrato">
                        <div class="pt-2 align-center">
                            <v-icon class="align-self-center" color="primary">
                                {{ getIconStatusContrato(pedido.contrato.status) }}
                            </v-icon>
                            <label class="align-self-center" style="font-weight: bold;">Status do contrato: {{
                                getDescricaoStatusContrato(pedido.contrato.status, pedido.docusign_falha,pedido.docusign_enviado)
                            }}</label>
                        </div>
                    </v-col>
                    <v-col v-if="(pedido.contrato.status !== '' || pedido.docusign_falha) && exibe_contrato"
                           class="d-flex align-center justify-center mb-4 flex-wrap">
                        <div v-if="pedido.contrato.status === StatusContrato.ContratoAssinado"
                             class="btn-contratos mb-2 position-relative">
                            <v-menu offset-y v-model="dropdown_documentos_aberto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" @click="visualizarDocumentos">
                                        Visualizar documentos
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item v-for="(item, index) in documentos" :key="index"
                                                 @click="visualizarDocumento(item)">
                                        <v-list-item-title>{{ item }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                        <v-btn class="ml-5 mb-2" v-if="pedido.contrato.status === StatusContrato.ContratoPendente"
                               color="secondary" @click="reenviarContrato">
                            Reenviar contrato
                        </v-btn>
                        <v-btn class="ml-5 mb-2" color="secondary" @click="getHistoricoReenvio">
                            Histórico
                            reenvios
                        </v-btn>
                        <v-btn class="ml-5 mb-2" v-if="pedido.contrato.status === StatusContrato.ContratoAssinado"
                               color="primary" @click="compartilharDocumentos">
                            Compartilhar documentos
                        </v-btn>
                        <v-btn class="ml-5 mb-2"
                               v-if="pedido.status_alocacao && pedido.status_alocacao.status_alocacao === StatusAlocacoes.FalhaAlocacao"
                               color="primary" @click="retentarAlocacao(pedido.id_pedido)">
                            Retentar Alocação da
                            Cota
                        </v-btn>
                    </v-col>
                    <div class="mx-1 mt-3 mb-5">
                        <DadosDaCompra :has-error="hasError" :pedido="pedido" :desconto="desconto"
                                       :permite-flavor-todos-produtos="!!permite_flavor_todos_produtos"
                                       :administradora="administradora" :seguro="seguro"
                                       :aguardando-pagamento-cliente="AguardandoPagamentoCliente" />
                    </div>
                    <div class="mx-1 mt-3 mb-5">
                        <v-layout wrap row-padding
                                  v-if="exibirBotoesBoleto() && !isVendaCancelada(pedido.status_pedido)">
                            <v-flex col-12>
                                <v-row>
                                    <v-col md="6" v-if="isBoletoVencido()">
                                        <v-btn id="ButtonReenviarBoleto" class="mt-3" block color="primary"
                                               @click="gerarNovoBoleto()">
                                            GERAR NOVO BOLETO
                                        </v-btn>
                                    </v-col>
                                    <v-col md="6">
                                        <v-btn id="ButtonEmailChanges"
                                               v-if="exibe_reenvio_email && !isVendaCancelada(pedido.status_pedido)"
                                               class="mt-3" block color="primary" @click="showChangedEmailHistory()"
                                               @close="closeChangedEmailHistory">
                                            HISTÓRICO DE AJUSTES DO E-MAIL
                                        </v-btn>
                                    </v-col>
                                    <v-col md="6">
                                        <v-btn id="ButtonAlterarPagamento" block color="primary"
                                               @click="exibirDialogTrocarFormaPagamento" class="mt-3"
                                               v-if="exibir_botao_troca_pagamento">
                                            Alterar Pagamento
                                        </v-btn>
                                    </v-col>
                                    <v-col md="6">
                                        <v-btn id="ButtonVisualizarBoleto" class="mt-3" block color="secondary"
                                               @click="verBoleto()">
                                            Visualizar boleto
                                        </v-btn>
                                    </v-col>
                                    <v-col md="6">
                                        <v-btn id="ButtonHistoricoBoleto" block color="secondary"
                                               @click="getHistoricoBoleto()" class="mt-3"
                                               v-if="pedido.historico_envio_boleto.length > 0">
                                            Histórico de Envio de Boletos
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-flex>
                        </v-layout>
                        <v-row>
                            <v-flex col-12 col-md-6>
                                <v-btn v-if="isOrderExpired && AguardandoPagamentoCliente" id="ButtonGerarNovoLink" block class="mt-3" color="primary" @click="gerarNovoLinkPagamento">
                                    Gerar novo link de pagamento
                                </v-btn>

                                <v-btn id="ButtonReenviarCodigo" block class="mt-3" v-if="AguardandoPagamentoCliente"
                                       color="primary" @click="atualizarEmail(pedido.cliente.email)">
                                    Reenviar email com código de pagamento
                                </v-btn>
                                <v-btn id="ButtonEmailChanges" class="mt-3" block color="primary"
                                       v-if="!exibirBotoesBoleto() && exibe_reenvio_email && !isVendaCancelada(pedido.status_pedido)"
                                       @click="showChangedEmailHistory()" @close="closeChangedEmailHistory">
                                    HISTÓRICO DE AJUSTES DO E-MAIL
                                </v-btn>
                            </v-flex>
                            <v-flex col-12 col-md-6>
                                <v-btn id="ButtonHistoricoLink" block color="secondary" @click="getHistoricoLink()"
                                       class="mt-3" v-if="AguardandoPagamentoCliente">
                                    Histórico de Envio de Links
                                </v-btn>
                                <v-btn id="ButtonAlterarPagamento" block color="primary"
                                       @click="exibirDialogTrocarFormaPagamento" class="mt-3"
                                       v-if="exibir_botao_troca_pagamento && !exibirBotoesBoleto() && !isVendaCancelada(pedido.status_pedido)">
                                    Alterar Pagamento
                                </v-btn>
                            </v-flex>
                        </v-row>
                    </div>
                    <div class="mb-5">
                        <v-row class="primary--text ma-1 pointer" @click="sections.cliente = !sections.cliente">
                            <h2>Dados do cliente</h2>
                            <v-spacer />
                            <v-icon color="primary" class="mt-1" :class="{ rotate90: sections.cliente }">
                                chevron_right
                            </v-icon>
                        </v-row>
                        <v-divider />
                        <collapse-transition>
                            <div class="ma-1 my-3" v-show="sections.cliente">
                                <v-layout wrap>
                                    <v-flex xs12 md6>
                                        <label>{{ isPessoaFisica() ? "CPF" : "CNPJ" }}</label>
                                        <p>
                                            {{ (isPessoaFisica() ? pedido.cliente.cpf : pedido.cliente.cnpj) || "-" }}
                                        </p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <label>{{ isPessoaFisica() ? "Nome" : "Razão social" }}</label>
                                        <p>
                                            {{ cliente() }}
                                        </p>
                                    </v-flex>
                                    <v-flex xs12 md6 v-if="!isPessoaFisica()">
                                        <label>Nome fantasia</label>
                                        <p>
                                            {{ nomeFantasia() }}
                                        </p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <label>
                                            {{ isPessoaFisica() ? "Data de nascimento" : "Data de fundação" }}
                                        </label>
                                        <p>{{ getData(pedido) }}</p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <label>{{ isPessoaFisica() ? "Nacionalidade" : "Atividade" }}</label>
                                        <p>
                                            {{ nacionalidadeAtividade() }}
                                        </p>
                                    </v-flex>
                                    <v-flex xs12 md6 v-if="isPessoaFisica()">
                                        <label>{{ "Sexo" }}</label>
                                        <p>
                                            {{ sexoNomeSocio() }}
                                        </p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <label>{{ isPessoaFisica() ? "Renda" : "Faturamento médio" }}</label>
                                        <p>{{ getMoney(pedido) }}</p>
                                    </v-flex>
                                    <v-flex xs12 md6 v-if="isPessoaFisica()">
                                        <label>Politicamente exposto</label>
                                        <p>{{ getPoliticamenteExposto() }}</p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <label>Telefone</label>
                                        <p>
                                            {{ getTelefone(pedido.cliente, pedido.instancia_cliente) }}
                                        </p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <label>Celular</label>
                                        <p>{{ getTelefoneCelular(pedido.instancia_cliente, pedido.cliente) }}</p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <label>E-mail</label>
                                        <p>{{ getEmail(pedido.instancia_cliente, pedido.cliente) }}</p>
                                        <v-tooltip bottom color="white"
                                                   v-if="shouldDisableEditButton && exibe_reenvio_email && !isVendaCancelada(pedido.status_pedido)">
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    <v-btn :disabled="shouldDisableEditButton" class="mt-2"
                                                           color="primary">
                                                        <v-icon size="18" class="pr-3" color="white">mdi-pencil</v-icon>
                                                        Editar e-mail
                                                    </v-btn>
                                                </span>
                                            </template>
                                            <div v-if="shouldDisableEditButton" style="color:#222">
                                                Impossível editar o e-mail para propostas alocadas, assinadas ou
                                                processando a
                                                criação do contrato
                                            </div>
                                        </v-tooltip>
                                        <v-btn
                                                v-else-if="exibe_reenvio_email && !isVendaCancelada(pedido.status_pedido)"
                                                @click="showChangeEmailDialog" class="mt-2" color="primary">
                                            <v-icon size="18" class="pr-3" color="white">mdi-pencil</v-icon>
                                            Editar e-mail
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </collapse-transition>
                    </div>

                    <div class="mb-5" v-if="!isPessoaFisica()">
                        <v-row class="primary--text ma-1 pointer" @click="sections.socios = !sections.socios">
                            <h2>Dados do(s) Sócio(s)</h2>
                            <v-spacer />
                            <v-icon color="primary" class="mt-1" :class="{ rotate90: sections.socios }">
                                chevron_right
                            </v-icon>
                        </v-row>
                        <v-divider />
                        <collapse-transition>
                            <div class="ma-1 my-3" v-show="sections.socios">
                                <v-layout wrap>
                                    <v-flex xs12 md6>
                                        <label>{{ "Nome" }}</label>
                                        <p>
                                            {{ pedido.cliente_pedido.nome_completo }}
                                        </p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <label>{{ "CPF" }}</label>
                                        <p>
                                            {{ pedido.cliente_pedido.cpf || "-" }}
                                        </p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <label>Politicamente exposto</label>
                                        <p>{{ getPoliticamenteExposto() }}</p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <label>Beneficiário Final</label>
                                        <p>{{ pedido.beneficiario.cpf == pedido.cliente.cpf_socio ? "Sim" : "Não" }}</p>
                                    </v-flex>
                                    <v-flex xs12 md6 v-if="pedido.beneficiario.cpf !== pedido.cliente.cpf_socio">
                                        <label>Nome do beneficiario</label>
                                        <p>
                                            {{ pedido.beneficiario.nome_completo ? pedido.beneficiario.nome_completo :
                                                pedido.cliente.nome_completo || "-" }}
                                        </p>
                                    </v-flex>
                                    <v-flex xs12 md6 v-if="pedido.beneficiario.cpf !== pedido.cliente.cpf_socio">
                                        <label>CPF do beneficiario</label>
                                        <p>
                                            {{ pedido.beneficiario.cpf ? pedido.beneficiario.cpf :
                                                pedido.cliente.cpf_socio ||
                                                "-" }}
                                        </p>
                                    </v-flex>
                                    <v-flex xs12 md6 v-if="pedido.beneficiario.cpf !== pedido.cliente.cpf_socio">
                                        <label>Politicamente exposto?</label>
                                        <p>
                                            {{ getBeneficiarioPoliticamenteExposto() ?
                                                getBeneficiarioPoliticamenteExposto() :
                                                getPoliticamenteExposto() || "-" }}
                                        </p>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </collapse-transition>
                    </div>
                    <div class="mb-5">
                        <v-row class="primary--text ma-1 pointer" @click="sections.endereco = !sections.endereco">
                            <h2>Endereço</h2>
                            <v-spacer />
                            <v-icon color="primary" class="mt-1" :class="{ rotate90: sections.endereco }">
                                chevron_right
                            </v-icon>
                        </v-row>
                        <v-divider />
                        <collapse-transition>
                            <div class="ma-1 my-3" v-show="sections.endereco">
                                <v-layout wrap>
                                    <v-flex xs12 md6>
                                        <label>CEP</label>
                                        <p>{{ enderecos[0] ? getCep(enderecos[0]) : "-" }}</p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <label>Nome do logradouro</label>
                                        <p>{{ enderecos[0].endereco || "-" }}</p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <label>Número</label>
                                        <p>{{ enderecos[0].numero || "-" }}</p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <label>Complemento</label>
                                        <p>{{ enderecos[0].complemento || "-" }}</p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <label>Bairro</label>
                                        <p>{{ enderecos[0].bairro || "-" }}</p>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <label>Cidade / Estado</label>
                                        <p>{{ enderecos[0].cidade.nome || "" }} - {{ enderecos[0].cidade.uf || "" }}</p>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </collapse-transition>
                    </div>
                    <v-row class="primary--text ma-1" v-if="!isVendaCancelada(pedido.status_pedido)">
                        <h2>Confirmações</h2>
                    </v-row>
                    <v-divider v-if="!isVendaCancelada(pedido.status_pedido)" />
                    <m-form ref="confirmacoes" class="mx-1 mt-3 mb-5">
                        <v-col v-if="!isVendaCancelada(pedido.status_pedido)">
                            <v-row class="mb-4">
                                <v-flex class="d-flex align-center" sm8 md9>
                                    <label class="v-label regular-label pr-2" for="GroupDivulgacao">Autorizo a
                                        divulgação de
                                        meus dados cadastrais exclusivamente para os participantes do grupo de
                                        consórcio?
                                        *</label>
                                </v-flex>
                                <v-flex class="d-flex align-center" sm4 md3>
                                    <v-radio-group id="GroupDivulgacao"
                                                   v-model="pedido.autoriza_divulgar_dados_cadastrais" :rules="[$rules.selected]"
                                                   row :disabled="!isVendaNaoGerada(pedido.status_pedido)">
                                        <v-row>
                                            <v-col cols="2">
                                                <v-radio id="RadioDivulgacaoSim" label="Sim" :value="true" />
                                            </v-col>
                                            <v-col cols="2">
                                                <v-radio style="margin-left: 25px" id="RadioDivulgacaoNao" label="Não"
                                                         :value="false" />
                                            </v-col>
                                        </v-row>
                                    </v-radio-group>
                                </v-flex>
                            </v-row>
                            <v-row v-if="exibirOpcaoConsentimentoWhatsapp" class="mb-4">
                                <v-flex class="d-flex align-center" sm8 md9>
                                    <label class="v-label regular-label pr-2" for="GroupWhatsapp">O Consorciado autoriza
                                        a
                                        Administradora a contatá-lo por aplicativo de mensagem, inclusive pelo WhatsApp,
                                        para
                                        formalizar o contrato de consórcio e encaminhar informações relativas a esse
                                        negócio e
                                        aos demais produtos e serviços ofertados? *</label>
                                </v-flex>
                                <v-flex class="d-flex align-center" sm4 md3>
                                    <v-radio-group id="GroupWhatsapp" v-model="pedido.aceita_comunicacao_whatsapp"
                                                   :rules="[$rules.selected]" row
                                                   :disabled="!isVendaNaoGerada(pedido.status_pedido)">
                                        <v-row>
                                            <v-col cols="2">
                                                <v-radio id="RadioWhatsappSim" label="Sim" :value="true" />
                                            </v-col>
                                            <v-col cols="2">
                                                <v-radio style="margin-left: 25px" id="RadioWhatsappNao" label="Não"
                                                         :value="false" />
                                            </v-col>
                                        </v-row>
                                    </v-radio-group>
                                </v-flex>
                            </v-row>
                        </v-col>
                        <div class="pt-1" v-if="!isVendaCancelada(pedido.status_pedido)">
                            <v-flex xs12>
                                <v-select
                                        label="Declaro que a presente cota de consórcio é adquirida com o propósito de:"
                                        id="SelectFinalidade" :filled="true" class="required" item-text="descricao"
                                        item-value="id_finalidade" outlined
                                        :disabled="!isVendaNaoGerada(pedido.status_pedido)" :items="finalidades"
                                        :rules="[$rules.required]" v-model="pedido.id_finalidade" />
                            </v-flex>
                            <v-flex xs12 v-show="tipo_cota_selecionado">
                                <v-select label="Tipo de Cota:" id="SelectTipoCota" class="required" item-text="label"
                                          item-value="cd_tipo_cota" outlined :items="tipos_cota"
                                          :rules="[$rules.needToHaveThatAttributeFilled(tipo_cota_selecionado, 'cd_tipo_cota')]"
                                          :return-object="true" :disabled="!isVendaNaoGerada(pedido.status_pedido)"
                                          :filled="true" v-model="tipo_cota_selecionado" />
                            </v-flex>
                        </div>
                        <v-col class="text-center red--text mb-6" v-if="!isVendaCancelada(pedido.status_pedido)">
                            Campos obrigatórios *
                        </v-col>
                        <v-layout row-padding class="justify-space-between">
                            <v-flex class="col">
                                <v-tooltip bottom color="white" :open-on-hover="is_venda_analise"
                                           v-if="deveMostrarBotaoVoltar(pedido.status_pedido, is_venda_analise)">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">
                                            <v-btn id="ButtonVoltar" :disabled="is_venda_analise" block
                                                   color="secondary" @click="voltar()"
                                                   style="margin-left: 0;">Voltar</v-btn>
                                        </span>
                                    </template>
                                    <div v-if="is_venda_analise" style="color:#222">
                                        Aguardando análise.
                                    </div>
                                </v-tooltip>
                            </v-flex>
                            <v-flex class="col">
                                <v-tooltip bottom color="white"
                                           v-if="pedido.status_pedido === StatusPedido.Rascunho && !remove_delete_sale_button">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">
                                            <v-btn id="ButtonApagarVenda" block color="error" @click="deletar()">
                                                Apagar Venda
                                            </v-btn>
                                        </span>
                                    </template>
                                </v-tooltip>
                            </v-flex>
                            <v-flex class="col">
                                <v-tooltip bottom color="white"
                                           v-if="!is_venda_reprovada && !isVendaCancelada(pedido.status_pedido) && !pedido.forma_pagamento === 'link' && ((isVendaNaoGerada(pedido.status_pedido) && !is_venda_reprovada) || (pedido.contrato.status === 'Assinado' && !pedido.pagamento_enviado) || ((!pedido.assinatura_obrigatoria && !pedido.pagamento_enviado) || (pedido.assinatura_obrigatoria && pedido.origem !== 'pagamento' && !pedido.pagamento_enviado && pedido.forma_pagamento === 'cartao')))">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">
                                            <v-btn id="ButtonProsseguir" block color="primary" @click="avancar()"
                                                   style="margin-right: 0;">
                                                Prosseguir com a venda
                                            </v-btn>
                                        </span>
                                    </template>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                    </m-form>
                </v-flex>
            </v-layout>
            <DialogChangeEmailHistory v-model="show_email_changed_history" @close="closeChangedEmailHistory"
                                      :id-pedido="pedido.id_pedido" />

            <DialogChangeEmail v-model="dialog_change_email" @change_email_outside="changeEmail"
                               :old-email="pedido.instancia_cliente.email || pedido.cliente.email" :pedido="pedido" @close="closeChangeEmailDialog" />

            <DialogHistorico v-model="show_historico_boleto" tipo-historico="boleto"
                             :historico="pedido.historico_envio_boleto" />

            <DialogHistorico v-model="show_historico_link" tipo-historico="link"
                             :historico="pedido.historico_envio_link" />

            <DialogHistorico v-model="show_historico_contrato" tipo-historico="contrato"
                             :historico="historico_contrato" />

            <DialogFormaPagamento @fechar="fecharDialogTrocarFormaPagamento" v-model="exibir_troca_pagamento"
                                  :pedido="pedido" v-if="exibir_troca_pagamento" />
            <DialogHistoryReasonAutorization v-model="showHistoryAuth" :historico="historico_motivo" :title="'HISTÓRICO DE PENDÊNCIAS'" />

            <botoes-proposta
                    :ativa-botao-carrinho="pedido.carrinho && !!pedido.carrinho.id_carrinho && (pedido.status_pedido !== StatusPedido.ReprovadoAnaliseCredito)" @toggleCarrinho="voltarAoCarrinho(pedido.id_pedido)"
                    @toggleVendas="voltarAoMinhasVendas" />
        </div>
    </v-container>
</template>

<script>
  import { alert, notification, trimZeros, swap, getNomeEmpresaPorIdEmpresa, isVendaNaoGerada, verifyIfPaidAndReturnInText, isVendaCancelada, getComissionadoNormalized, getDescricaoStatusContrato, unmask } from '@/plugins/helpers'
  import { FormasPagamento, OpcoesFuroDesc, PoliticamenteExposto, StatusPedido, TipoPessoa, StatusContrato, FormasPagamentoDesc } from '@/plugins/constants'
  import { getTextCodigoPagamento } from '@/plugins/textFormatters'
  import { cep, money, toDateBR } from '@/plugins/formatters'
  import DialogFormaPagamento from '@/dialogs/DialogFormaPagamento'
  import DialogChangeEmail from '@/dialogs/DialogChangeEmail'
  import DialogChangeEmailHistory from '@/dialogs/DialogChangeEmailHistory'
  import { get } from 'lodash'
  import reenviarContratoMixin from '@/mixins/reenviarContratoMixin'
  import DialogHistorico from '@/dialogs/DialogHistorico'
  import Color from 'color'
  import { colorRes } from '@/plugins/flavors'
  import Confirmacao from '@/views/cadastro/confirmacao/Confirmacao'
  import creditAnalysis from '@/mixins/creditAnalysis'
  import detalhesAndResumo from '@/mixins/detalhesAndResumo'
  import IndicadorDecisaoCredito from '../components/analise-credito/IndicadorDecisaoCredito.vue'
  import { AlertTypes } from '../plugins/alerts_types'
  import { SituationAnalysisCredit } from '../plugins/constants'
  import { icones_status_hashmap } from '../plugins/listaStatusStyles'
  import DadosDaCompra from '../fragments/InformacoesProposta/DadosDaCompra.vue'
  import { pedido_default } from '../plugins/pedido_default'
  import { StatusAlocacoes } from '../plugins/status_alocacoes'
  import checarAlocacaoMixin from '../mixins/checarAlocacaoMixin'
  import BotoesProposta from '../components/BotoesProposta.vue'
  import BotoesPropostaMixin from '../mixins/BotoesPropostaMixin'
  import store from '../store'
  import { mapState } from 'vuex'
  import telefonesMixin from '@/mixins/telefonesMixin'
  import emailMixin from '@/mixins/emailMixin'
  import DialogHistoryReasonAutorization from './painel/credit-analysis/consultation-reports-components/DialogHistoryReasonAutorization.vue'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'

  export default {
    name: 'DetalhesVenda',
    components: { BotoesProposta, DialogHistorico, Confirmacao, DialogFormaPagamento, DialogChangeEmail, DialogChangeEmailHistory, IndicadorDecisaoCredito, DadosDaCompra, DialogHistoryReasonAutorization },
    mixins: [reenviarContratoMixin, creditAnalysis, detalhesAndResumo, checarAlocacaoMixin, BotoesPropostaMixin, telefonesMixin, emailMixin],
    data: () => ({
      StatusAlocacoes,
      tipos_cota: [],
      historico_motivo: [],
      houve_pendencia: false,
      tipo_cota_selecionado: null,
      is_quota_allocated: false,
      can_show_email_button: false,
      show_email_changed_history: false,
      dialog_change_email: false,
      exibir_troca_pagamento: false,
      exibir_botao_troca_pagamento: false,
      reserva_valida: true,
      desconto: false,
      hasError: false,
      sections: {
        cliente: true,
        endereco: false,
        socios: true
      },
      pedido: pedido_default,
      enderecos: [
        {
          id_endereco: '',
          id_cliente: '',
          cep: '',
          endereco: '',
          numero: '',
          complemento: '',
          bairro: '',
          estado: '',
          id_cidade: '',
          principal: '',
          ativo: '',
          cidade: {
            nome: ''
          }
        }
      ],
      finalidades: [],
      documentos: [],
      exibe_contrato: true,
      show_historico_boleto: false,
      show_historico_link: false,
      show_historico_contrato: false,
      showHistoryAuth: false,
      historico_contrato: [],

      permite_flavor_todos_produtos: false,
      administradora: '',
      exibe_reenvio_whatsapp: false,
      exibe_reenvio_email: false,
      m_tela: '',
      forma_pagamento: '',
      exibirOpcaoConsentimentoWhatsapp: false
    }),
    computed: {
      ...mapState(['permite_multiplicar_cota']),
      OpcoesFuroDesc: () => OpcoesFuroDesc,
      StatusPedido: () => StatusPedido,
      TipoPessoa: () => TipoPessoa,
      StatusContrato: () => StatusContrato,
      FormasPagamentoDesc: () => FormasPagamentoDesc,
      shouldDisableEditButton () {
        return !(!this.is_quota_allocated && this.can_show_email_button && this.pedido.contrato.status === StatusContrato.ContratoPendente && (!isVendaNaoGerada(this.pedido.status_pedido) && this.pedido.status_pedido !== StatusPedido.Cancelado))
      },
      /**
       * @return {boolean}
       */
      AguardandoPagamentoCliente () {
        return this.pedido.forma_pagamento === FormasPagamento.Link && !isVendaNaoGerada(this.pedido.status_pedido) && this.pedido.status_pedido !== StatusPedido.Cancelado && this.pedido.status_pedido !== StatusPedido.Pago && this.pedido.status_pedido !== StatusPedido.CanceladoNewcon
      },
      seguro () {
        return this.$session.get('configuracoes').seguro
      },
      dropdown_documentos_aberto: {
        get () {
          return this.documentos.length > 0
        },
        set (aberto) {
          if (!aberto) {
            this.documentos = []
          }
        }
      },
      cssProps () {
        return {
          '--secondaryTransparent': Color(colorRes().secondary).alpha(0.15),
          '--primaryTransparent': Color(colorRes().primary).alpha(0.15)
        }
      },
      current_page () {
        return this.permite_multiplicar_cota ? 5 : 4
      },
      Steps () {
        let Steps = [{ icon: 'rod-cadastro', text: 'Cadastro' }, { icon: 'rod-produto', text: 'Produto' }, { icon: 'rod-grupo', text: 'Grupo' }, { icon: 'ol-book', text: 'Confirmação' }, { icon: 'gesture', text: 'Contrato' }, { icon: 'rod-cartao', text: 'Pagamento' }]
        if (this.exibirAssinaturaContrato && this.exibirContratoAlocacao) {
          Steps = swap(Steps, 4, 5)
        }

        if (this.permite_multiplicar_cota) {
          Steps.splice(3, 0, { icon: 'mdi-cart-variant', text: 'Cotas' })
        }
        if (this.fluxoProduto) {
          Steps = swap(Steps, 0, 1)
          return swap(Steps, 1, 2)
        }

        return Steps
      },
      isOrderExpired () {
        const dataValidade = this.pedido.data_validade
        const dataAtual = new Date().toISOString().split('T')[0]

        return dataValidade < dataAtual
      }
    },
    watch: {
      dropdown_documentos_aberto (aberto) {
        if (!aberto) {
          this.limparDocumentos()
        }
      }
    },
    async mounted () {
      this.permite_flavor_todos_produtos = this.$session.get('permite_venda_todos_produtos')
      this.exibe_reenvio_email = this.$session.get('exibe_reenvio_email')
      let id_pedido = this.$session.get('id_pedido_detalhes_venda')

      this.exibe_contrato = this.$session.get('exibe_contratos_sistema')
      if (id_pedido > 0) {
        store.commit('loadingStart')
        try {
          const res = await this.$http.get(`/vendas/${id_pedido}`)
          this.desconto = res.data.desconto
          res.data.beneficiario = { ...this.pedido.beneficiario, ...res.data.beneficiario }
          res.data.cliente_pedido = { ...this.pedido.cliente_pedido, ...res.data.cliente_pedido }
          res.data.cliente = { ...this.pedido.cliente, ...res.data.cliente }
          res.data.produto = { ...this.pedido.produto, ...res.data.produto }
          res.data.bem = { ...this.pedido.bem, ...res.data.bem }
          res.data.grupo = { ...this.pedido.grupo, ...res.data.grupo }
          res.data.plano = { ...this.pedido.plano, ...res.data.plano }
          res.data.analiseCredito = { ...this.pedido.analiseCredito, ...res.data.analiseCredito }
          res.data.analiseCredito = { ...this.pedido.status_alocacao, ...res.data.status_alocacao }
          this.pedido = { ...this.pedido, ...res.data }
          await this.getPedidoPagamento(this.pedido.status_pedido)
          await this.getQuotaAllocationStatus()
          this.convertNumberToBooleanIfNotRascunho()
          this.exibirOpcaoConsentimentoWhatsapp = !!res.data.exibir_opcao_consentimento_whatsapp
          if (this.pedido.cliente.enderecos.length > 0) {
            this.enderecos = this.pedido.cliente.enderecos
          }
          if (this.pedido.enviado) {
            this.$emit('finalizado')
          }
          if (this.pedido.status_pedido === StatusPedido.AguardandoDecisaoAnaliseCredito) {
            this.setVendaAnalise()
          } else if (this.pedido.status_pedido === StatusPedido.ReprovadoAnaliseCredito) {
            this.setVendaReprovada()
          } else if (this.pedido.status_pedido === StatusPedido.AprovadoAnaliseCredito) {
            this.setVendaAprovada()
          } else if ((this.pedido.autorizacao_analise_cadastral_backoffice && this.pedido.motivo_decisao_credito) || (this.pedido.autorizacao_analise_cadastral_backoffice === null && this.pedido.motivo_decisao_credito && this.pedido.analiseCredito.situacao === SituationAnalysisCredit.APROVADO)) {
            this.setVendaAprovada()
          }
          if (this.pedido.seguro === null) {
            this.pedido.seguro = this.seguro.valor_padrao
          }

          if (this.pedido.msg_erro) {
            alert(this.pedido.msg_erro)
          } else {
            this.$emit('input', { ...this.$route.params, ...this.pedido })
          }

          if (this.permite_flavor_todos_produtos) {
            this.administradora = getNomeEmpresaPorIdEmpresa(res.data.grupo.id_empresa)
          }
          if (!this.pedido.enviado) {
            await this.avisoPedido(id_pedido)
          }
        } catch (error) {
          this.hasError = true
          notification(AlertTypes.ERROR, error, 'Não foi possível buscar a venda.')
        } finally {
          await this.getTipoCotas(this.pedido.produto.id_produto)
          this.aparece_tipo_cota = this.tipos_cota.length > 0
          store.commit('loadingDone')
        }
      } else {
        if (this.pedido.seguro === null) {
          this.pedido.seguro = this.seguro.valor_padrao
        }
      }
      this.exibe_reenvio_whatsapp = this.$session.get('exibe_reenvio_whatsapp')
      this.$http.get('/finalidades').then(result => {
        this.finalidades = result.data.Finalidades
        this.finalidades.unshift({ id_finalidade: null, descricao: 'Selecione uma finalidade' })
      })

      if (this.pedido.id_consulta) {
        await this.historicoPendencia(this.pedido.id_consulta)
      }
      window.scrollTo(0, 0)
    },
    methods: {
      getDescricaoStatusContrato,
      retentarAlocacao (id_pedido) {
        this.checarAlocacaoCota(id_pedido)
      },
      async historicoPendencia (id_consulta) {
        await this.$http
          .get(`/credit_analysis/history_reason/${id_consulta}`)
          .then(res => {
            this.historico_motivo = res.data
            this.houve_pendencia = res.data.some(
              motivo => motivo.situacao_antiga === SituationAnalysisCredit.PENDENCIA_CADASTRAL
            )
          })
          .catch(e => {
            notification('error', e, 'Não foi possível exibir os motivos.')
          })
      },
      abrirHistoricoPendencias () {
        sendAnalyticsEvent(this.$gtag, 'alterar_dados_pendentes', {
          id_pedido: this.pedido.id_pedido,
          hierarquia: this.$session.get('hierarquia_comercial'),
          valor_credito: this.pedido.analiseCredito.vl_credito,
          bem: this.pedido.bem.nome_bem,
          cliente: {
            cpf_cnpj: this.pedido.cliente.pessoa === TipoPessoa.Fisica ? unmask(this.pedido.cliente.cpf) : unmask(this.pedido.cliente.cnpj)
          }
        })
        this.showHistoryAuth = true
      },
      voltarParaMinhasVendas () {
        this.$router.push({ name: 'minhas-vendas' })
      },
      deveMostrarBotaoVoltar (status, isAnalise) {
        return (isAnalise && (this.isVendaNaoGerada(status) || this.isVendaCancelada(status)) && status !== StatusPedido.ReprovadoAnaliseCredito)
      },
      async getTipoCotas (id_produto) {
        await this.$http.get(`/tipo_cotas/produto/${id_produto}`).then(result => {
          if (result.data.tipos_cota.length > 0) {
            this.tipos_cota = result.data.tipos_cota
            if (this.pedido.cd_tipo_cota) {
              const tipoCotaSelecionado = this.tipos_cota.find(tipo => tipo.cd_tipo_cota === this.pedido.cd_tipo_cota)
              if (tipoCotaSelecionado) {
                this.tipo_cota_selecionado = tipoCotaSelecionado
              }
            }
          }
        })
      },
      isVendaCancelada (status_pedido) {
        return isVendaCancelada(status_pedido)
      },
      verifyIfPaidAndReturnInText (status_pedido) {
        return verifyIfPaidAndReturnInText(status_pedido)
      },
      convertNumberToBooleanIfNotRascunho () {
        if (!isVendaNaoGerada(this.pedido.status_pedido)) {
          this.pedido.aceita_comunicacao_whatsapp = !!this.pedido.aceita_comunicacao_whatsapp
          this.pedido.autoriza_divulgar_dados_cadastrais = !!this.pedido.aceita_comunicacao_whatsapp
        }
      },
      changeEmail (newEmail) {
        this.pedido.cliente.email = newEmail
        this.pedido.instancia_cliente.email = newEmail
      },
      fecharDialogTrocarFormaPagamento () {
        this.exibir_troca_pagamento = false
        this.$router.go(0)
      },
      exibirDialogTrocarFormaPagamento () {
        this.exibir_troca_pagamento = true
      },
      closeChangeEmailDialog () {
        this.dialog_change_email = false
      },
      showChangeEmailDialog () {
        this.dialog_change_email = true
      },
      async getPedidoPagamento (status_pedido) {
        const estaPago = status_pedido === StatusPedido.Pago || status_pedido === StatusPedido.AguardandoAssinaturaContratoAlocacao
        this.exibir_botao_troca_pagamento = !estaPago && !isVendaCancelada(status_pedido)
      },
      async getQuotaAllocationStatus () {
        try {
          await this.$http.get(`/proposta/allocation_status/${this.pedido.id_pedido}`).then(response => {
            this.is_quota_allocated = response.data.is_quota_allocated
          })
        } catch (err) {
          this.is_quota_allocated = false
        }
        this.can_show_email_button = true
      },
      getComissionado () {
        return this.pedido.cd_comissionado + ' - ' + this.pedido.nm_comissionado || '-'
      },
      isPessoaFisica () {
        return this.pedido.cliente.pessoa === TipoPessoa.Fisica
      },
      cliente () {
        return (this.isPessoaFisica() ? this.pedido.cliente.nome_completo : this.pedido.cliente_pedido.razao_social) || '-'
      },
      nacionalidadeAtividade () {
        return (this.isPessoaFisica() ? this.pedido.cliente.nacionalidade : this.pedido.cliente.atividade.nome) || '-'
      },
      sexoNomeSocio () {
        return this.isPessoaFisica() ? _.startCase(this.pedido.cliente.genero) : '-'
      },
      nomeFantasia () {
        return this.pedido.cliente_pedido.nome_fantasia
      },
      getParcela () {
        let parcela = parseFloat(this.pedido.plano.vl_parcela_com_seguro) || 0
        if (this.pedido.seguro) {
          return money(parcela - (parcela * parseFloat(this.pedido.grupo.pe_seguro)) / 100)
        }
        return money(parcela)
      },
      getData (pedido) {
        let data = pedido.cliente.pessoa === TipoPessoa.Fisica ? pedido.cliente.data_nascimento : pedido.cliente_pedido.data_fundacao
        if (data) {
          return toDateBR(data)
        }
        return '-'
      },
      getMoney (pedido) {
        let renda = pedido.cliente.pessoa === TipoPessoa.Fisica ? pedido.cliente.renda : pedido.cliente.faturamento_medio
        if (renda) {
          return money(renda)
        }
        return '-'
      },
      async atualizarEmail (email) {
        const { id_cliente, email: email_antigo } = this.pedido.cliente

        if (email_antigo !== email) {
          await this.$http.patch(`/clientes/${id_cliente}/email`, { email })

          this.pedido.cliente.email = email

          this.$emit('input', this.pedido)
        }

        if (this.pedido.forma_pagamento === FormasPagamento.Link) {
          this.reenviarEmail()
        } else {
          this.emitirBoleto()
        }
      },
      getCep (endereco) {
        const _cep = endereco.cep
        return _cep ? cep(_cep) : '-'
      },
      async reenviarEmail () {
        await this.$http.post('/proposta/linkpagamento/reenviar', { id_pedido: this.pedido.id_pedido })
        notification(AlertTypes.INFO, 'Link de pagamento enviado com sucesso!')
      },
      async gerarNovoLinkPagamento () {
        await this.$http.post('/proposta/linkpagamento', { id_pedido: this.pedido.id_pedido, email: this.pedido.instancia_cliente.email, recriacao_link: true }).then(
          (response) => {
            const codigo_pagamento_cliente = response.data.codigo_pagamento_cliente
            const data_validade = response.data.data_validade

            this.pedido.codigo_pagamento_cliente = codigo_pagamento_cliente
            this.pedido.data_validade = data_validade
            notification(AlertTypes.INFO, 'Link de pagamento enviado com sucesso!')
          }).catch((error) => {
          console.error('Erro ao gerar o link de pagamento:', error)
          notification(AlertTypes.ERROR, 'Ocorreu um erro ao gerar o link de pagamento. Tente novamente mais tarde.')
        })
      },
      isBoletoVencido () {
        if (this.pedido.historico_envio_boleto.length === 0) {
          return false
        }

        const ultimoEnvio = this.pedido.historico_envio_boleto.reduce((maisRecente, atual) => {
          return new Date(atual.data_hora_envio) > new Date(maisRecente.data_hora_envio) ? atual : maisRecente
        })

        const dataAtual = new Date()
        const dataUltimoEnvio = new Date(ultimoEnvio.data_hora_envio)
        const diferencaEmMilissegundos = dataAtual - dataUltimoEnvio
        const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24)
        return diferencaEmDias >= 1
      },
      gerarNovoBoleto () {
        alert({
          text: `Ao gerar um novo boleto, será registrado no DDA do cliente (caso o mesmo tenha aderido) essa nova cobrança, caso queira somente reenviar o boleto da venda, utilizar o botão “Visualizar Boleto”.`,
          buttons: {
            Cancelar: () => true,
            Confirmar: async () => this.atualizarEmail(this.pedido.cliente.email)
          }
        })
      },
      getPoliticamenteExposto () {
        if (this.pedido.cliente.politicamente_exposto) {
          return this.pedido.cliente.politicamente_exposto === PoliticamenteExposto.NaoPoliticamenteExposto ? 'Não' : 'Sim'
        }
        return '-'
      },
      getBeneficiarioPoliticamenteExposto () {
        if (this.pedido.beneficiario.politicamente_exposto) {
          return this.pedido.beneficiario.politicamente_exposto === PoliticamenteExposto.NaoPoliticamenteExposto ? 'Não' : 'Sim'
        }
        return '-'
      },
      isVendaNaoGerada (status_venda) {
        return isVendaNaoGerada(status_venda)
      },
      exibirResumo (status_venda) {
        return isVendaNaoGerada(status_venda) && status_venda !== StatusPedido.ReprovadoAnaliseCredito
      },
      voltar () {
        if (!isVendaNaoGerada(this.pedido.status_pedido) || (this.pedido.id_reserva && this.pedido.reserva.completa) || this.pedido.status_pedido === StatusPedido.ReprovadoAnaliseCredito || isVendaCancelada(this.pedido.status_pedido)) {
          this.$router.push({ name: 'minhas-vendas' })
        } else {
          alert({
            text: 'Alterar as condições comerciais poderá fazer com que a consulta de crédito seja refeita. Deseja prosseguir?',
            buttons: {
              Fechar: () => { },
              Confirmar: () => this.$emit('prevPage')
            }
          })
        }
      },
      fluxoProduto () {
        return this.$route.name === 'iniciar-venda'
      },
      trimZeros,
      deletar () {
        alert({
          text: 'Tem certeza que deseja apagar a venda? Esta ação não pode ser desfeita',
          buttons: {
            Cancelar: () => true,
            Confirmar: () => {
              this.$http.delete(`vendas/${this.pedido.id_pedido}`).then(() => {
                alert({
                  text: 'Venda apagada com sucesso!',
                  buttons: {
                    OK: () => {
                      this.$emit('finalizado')
                      this.$router.replace('minhas-vendas')
                    }
                  }
                })
              })
            }
          }
        })
      },
      avancar () {
        const radio_seguro = this.$refs.seguro_radio
        const confirmacoes = this.$refs.confirmacoes
        if (this.seguro.exibir && !radio_seguro.validate(true)) {
          notification(AlertTypes.WARN, 'Por favor, decida sobre o seguro')
          return
        }

        if (typeof this.pedido.autoriza_divulgar_dados_cadastrais !== 'boolean') {
          // Se o valor não for boolean ele não foi iniciado
          notification(AlertTypes.WARN, 'Por favor decida sobre a autorização para divulgação dos dados cadastrais')
          return
        }
        if (typeof this.pedido.aceita_comunicacao_whatsapp !== 'boolean') {
          // Se o valor não for boolean ele não foi iniciado
          notification(AlertTypes.WARN, 'Por favor decida sobre a autorização para contatar o cliente via aplicativo de mensagem')
          return
        }
        if (confirmacoes.validate()) {
          this.pedido.plano.valor_parcela = parseFloat(this.pedido.plano.vl_parcela_com_seguro) - (!this.pedido.seguro * parseFloat(this.pedido.grupo.pe_seguro) * parseFloat(this.pedido.plano.vl_parcela_com_seguro)) / 100
          this.pedido.identificador_representante_tribanco = this.$session.get('identificador_representante_tribanco')
          const comissionadoData = getComissionadoNormalized(this.$session.get('id_comissionado_venda'), this.$session.get('comissionados'), this.$session.get('vendas_backoffice'))
          this.pedido.flavor_atual = this.$session.get('flavor')
          this.pedido.id_comissionado = comissionadoData.id_comissionado
          this.pedido.cd_comissionado = comissionadoData.cd_comissionado
          this.pedido.nm_comissionado = comissionadoData.nm_comissionado
          this.pedido.nm_ponto_venda = this.$session.get('nm_ponto_venda')
          this.pedido.cd_ponto_venda = this.$session.get('cd_ponto_venda')
          this.$http.post('/vendas', this.pedido).then(async () => {
            if (!(await this.validarDadosDaVenda(this.pedido.id_pedido))) {
              return
            }
            if (!(await this.checkAnaliseCadastral(this.pedido.id_pedido, this.pedido.grupo_pontual, this.pedido.grupo_praja))) {
              return
            }
            this.$http.patch(`/vendas/${this.pedido.id_pedido}/salvarseguro`, { seguro: this.pedido.seguro }).then(() => {
              this.$router.push({ name: 'cadastro', params: this.pedido })
            })
          })
        }
      },
      toggleSeguro () {
        if (this.seguro.permite_editar) {
          if (!this.pedido.seguro) {
            alert({
              text: 'O Seguro Prestamista da direito ao sorteio mensal do Prêmio Pontualidade, que é uma recompensa em dinheiro que não tem vínculo com a cota, por isso, poderá utiliza-la da forma que desejar. Também é uma garantia de que a inadimplência poderá ser evitada, no caso de sinistro.',
              buttons: {
                'Desistir do seguro': () => true,
                'Aceitar o seguro': () => {
                  this.pedido.seguro = true
                }
              }
            })
          }
        } else {
          this.$nextTick(function () {
            this.pedido.seguro = this.seguro.valor_padrao
          })
        }
      },
      verBoleto () {
        window.open(`${this.ws}/boleto/${this.pedido.id_documento}`)
      },
      emitirBoleto () {
        this.$http
          .post('/proposta/boleto/enviar', {
            id_pedido: this.pedido.id_pedido,
            email: this.pedido.cliente.email,
            reenvio: true,
            vendedor: true
          })
          .then(() => {
            notification(AlertTypes.SUCCESS, 'Forma de pagamento enviada com sucesso! Em breve você receberá um e-mail com o boleto.')
          })
          .catch(err => {
            this.getHistoricoBoleto()
            notification(AlertTypes.ERROR, err, 'Não foi possível reemitir o boleto')
          })
      },
      exibirBotoesBoleto () {
        return [StatusPedido.Finalizado, StatusPedido.Enviado, StatusPedido.AguardandoPagamento, StatusPedido.AguardandoAssinaturaContratoAlocacao].includes(this.pedido.status_pedido) && this.pedido.forma_pagamento === FormasPagamento.Boleto
      },
      copiarLinkPagamento () {
        const el = document.createElement('textarea')
        el.value = this.pedido.link_pagamento
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        notification('info', 'Link de pagamento copiado.')
      },
      getIconStatusContrato (status) {
        if (icones_status_hashmap[status]) {
          return icones_status_hashmap[status]
        }
        return 'work_off'
      },
      compartilharDocumentos () {
        alert({
          text: 'Deseja compartilhar todos os documentos do contrato via e-mail?',
          buttons: {
            Nao: { text: 'Não' },
            Sim: async () => {
              try {
                await this.$http.post(`/contrato/compartilhar/${this.pedido.contrato.id_contrato}`)
                notification(AlertTypes.SUCCESS, 'Contrato agendado para compartilhamento com sucesso!')
              } catch (e) {
                notification(AlertTypes.ERROR, e, 'Não foi possível compartilhar os documentos')
              }
            }
          }
        })
      },
      reenviarContrato () {
        this.showDialogReenviaContrato(this.pedido.contrato.id_contrato, this.pedido.whatsapp, this.exibe_reenvio_whatsapp)
      },
      async visualizarDocumentos () {
        try {
          const { data } = await this.$http.get(`/contrato/documentos/${this.pedido.contrato.hash_contrato}`)
          if (this.pedido.contrato.origem_assinatura_consorcio) {
            window.open(data[0].url, '_blank')
          } else {
            this.documentos = data
          }
        } catch (e) {
          const status_code = get(e, 'response.status', 500)
          if (status_code === 404) {
            notification(AlertTypes.ERROR, 'Falha ao identificar documentos da proposta. Tente novamente mais tarde.')
          } else {
            notification(AlertTypes.ERROR, e, 'Não foi possível visualizar os documentos')
          }
        }
      },
      visualizarDocumento (documento) {
        window.open(`${this.ws}/contrato/baixar/${this.pedido.contrato.hash_contrato}/${documento}`)
      },
      limparDocumentos () {
        // Espero 500ms pra garantir que o usuário consiga baixar o documento antes de deletar ele
        setTimeout(async () => {
          this.$http.delete(`/contrato/documentos/${this.pedido.contrato.id_contrato}`)
          this.documentos = []
        }, 500)
      },
      async getHistoricoBoleto () {
        try {
          const { data } = await this.$http.get(`/vendas/${this.pedido.id_pedido}/historicoboleto`)
          this.pedido.historico_envio_boleto = data
          this.show_historico_boleto = true
        } catch (e) {
          notification(AlertTypes.ERROR, e, 'Não possível atualizar o histórico de envio de boletos ao cliente. É possível que você veja uma listagem defasada')
        }
      },
      async getHistoricoLink () {
        try {
          const { data } = await this.$http.get(`/vendas/${this.pedido.id_pedido}/historicolink`)
          this.pedido.historico_envio_link = data
          this.show_historico_link = true
        } catch (e) {
          notification(AlertTypes.ERROR, e, 'Não possível atualizar o histórico de envio de link ao cliente. É possível que você veja uma listagem defasada')
        }
      },
      async getHistoricoReenvio () {
        this.$http
          .get(`/contrato/historico_contrato/${this.pedido.id_pedido}`)
          .then(result => {
            this.historico_contrato = result.data
            this.show_historico_contrato = true
          })
          .catch(err => notification(AlertTypes.ERROR, err, 'Não foi possível buscar o contrato!'))
      },
      closeChangedEmailHistory () {
        this.show_email_changed_history = false
      },
      showChangedEmailHistory () {
        this.show_email_changed_history = true
      },
      getTextCodigoPagamento (formaPagamento, codigoPagamentoCliente, dataValidade) {
        return getTextCodigoPagamento(formaPagamento, codigoPagamentoCliente, dataValidade)
      }
    }
  }
</script>
<style lang="scss" scoped>
.header-steps {
    border-bottom: 1px solid var(--lightgray);
}

.steps-container {
    max-width: 1000px;
    border-bottom: 1px solid var(--lightgray);
    white-space: nowrap;
}

.steps-container .v-icon {
    vertical-align: middle;
    font-size: 18px;
    margin-right: 5px;
    margin-top: -2px;
}

.steps-container .step-label {
    display: block !important;
    text-transform: uppercase;
    font-size: 14px;
    margin-bottom: 0;
}

.steps-container .step-label,
.steps-container .v-icon {
    color: var(--gray);
}

.steps-container .v-stepper__step--active {
    background: var(--secondaryTransparent);
}

.steps-container .v-stepper__step--active .step-label,
.steps-container .v-stepper__step--active .v-icon {
    color: var(--secondary);
}

.steps-container .v-stepper__step--complete .step-label,
.steps-container .v-stepper__step--complete .v-icon {
    color: var(--primary);
}

.step-content {
    padding: 15px;
}

</style>

<style lang="scss" scoped>
label {
    font-size: 1rem;
    color: var(--darkgray);
}

p {
    color: var(--dark);
    font-size: 1.1rem;
}

.lista-documentos {
    width: 200px;
    z-index: 1;

    .theme--light.v-text-field--outlined {
        margin-top: 0;
    }
}

.regular-label {
    font-size: 13px;
    line-height: 18px;
}
</style>
